<!--Forgot Password Starts-->
<section id="create-password" [ngClass]="getClassBackground()">
  <div class="container-fluid forgot-password-bg">
    <div
      class="row full-height-vh m-0 d-flex align-items-center justify-content-center"
    >
      <div class="col-md-6 col-sm-6">
        <div class="card">
          <div class="card-content">
            <div class="card-body fg-image">
              <div class="row m-0">
                <div
                  class="col-lg-6 col-md-6 bg-white px-4 pt-3"
                  [ngClass]="{ 'loading-background': loading }"
                >
                  <h4 class="card-title mb-2">
                    {{ "common.write-pass" | translate }}
                  </h4>
                  <br />
                  <p>{{"common.password-actions.length" | translate}}</p>
                  <p>{{"common.password-actions.chars" | translate}}</p>
                  <form [formGroup]="form" (ngSubmit)="onSubmit()">
                    <div class="form-group mb-3">
                      <p style="margin-bottom: 0 !important">
                        {{ "common.new-pass" | translate }}*
                      </p>
                      <input
                        formControlName="password"
                        type="password"
                        id="password"
                        class="form-control rounded-1"
                        [type]="showPassword ? 'text' : 'password'"
                      />
                    </div>
                    <div class="form-group mb-3">
                      <p style="margin-bottom: 0 !important">
                        {{ "common.write-pass-again" | translate }}*
                      </p>
                      <input
                        formControlName="confirmPassword"
                        type="password"
                        id="confirmPassword"
                        class="form-control rounded-1"
                        [type]="showPassword ? 'text' : 'password'"
                      />
                    </div>
                    <div class="form-group password-wrapper col-101">
                      <button
                        type="button"
                        class="toggle-password btn-eye"
                        (click)="showPassword = !showPassword"
                        >
                        <img
                        src="assets/img/svg/login-eye-{{showPassword ? 'on' : 'off' }}.svg"
                        alt="Mostrar"
                        />
                      </button>
                      <span>{{"login.show-password" | translate}}</span>
                    </div>
                    <div class="row fg-actions d-flex justify-content-between">
                      <div class="col-12">
                        <button
                          class="btn btn-block rounded-1"
                          [ngClass]="getClassRecoveryButton()"
                          mat-button
                          [disabled]="!form.valid || loading"
                        >
                          <a class="text-decoration-none text-white">
                            {{ "common.send" | translate }}
                          </a>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
                <div *ngIf="loading" class="row">
                  <app-loading [userType]="typeUser"></app-loading>
                </div>
                <div class="col-lg-6 d-none d-lg-block text-center py-3">
                  <img
                    src="assets/img/gallery/lock.png"
                    alt=""
                    class="img-fluid"
                    width="300"
                    height="230"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Forgot Password Ends-->
